import { take, put, race, select, takeEvery } from 'redux-saga/effects';
import {
  OPEN_NEW_MESSAGE_DIALOG,
  NEW_MESSAGE_DIALOG,
  CANCEL_NEW_MESSAGE_DIALOG,
  SUBMIT_NEW_MESSAGE_FORM,
} from './constants';
 // Removed unused imports
import {  setCurrentPageDialog, removeCurrentPageDialog  } from '@/features/PageLayout/pageLayoutSlice';
import { sendNewMessage } from './api';
export function* submitNewMessageForm(action) {
  const newMessageFormValue = action.payload;
  const addresses = newMessageFormValue.get('messageTo');
  const subject = newMessageFormValue.get('messageSubject');
  const newMessageText = newMessageFormValue.get('messageText');
  const data = {
    addresses: JSON.stringify([addresses]),
    subject,
    text: newMessageText,
  };
  yield sendNewMessage(data);
}
export function* openNewMessageDialog() {
  yield put(setCurrentPageDialog({ dialog: NEW_MESSAGE_DIALOG }));
  const { submit, cancel } = yield race({
    submit: take(SUBMIT_NEW_MESSAGE_FORM),
    cancel: take(CANCEL_NEW_MESSAGE_DIALOG),
  });
  if (submit) {
    yield submitNewMessageForm(submit);
    yield put(removeCurrentPageDialog(NEW_MESSAGE_DIALOG));
  } else if (cancel) {
    yield put(removeCurrentPageDialog(NEW_MESSAGE_DIALOG));
  }
}
export function* root() {
  // FIX: Wrap in array for consistency with other sagas
  yield [
    takeEvery(OPEN_NEW_MESSAGE_DIALOG, openNewMessageDialog)
  ];
}
// FIX: Export as default array
export default [root];